import { Card, Table, Tag, Space } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/lib/axios'

interface PrenotazioneRow {
  id: number
  data_ora?: string
  stato?: string
  tipo_servizio?: string
  customer?: { nome?: string; cognome?: string }
  vehicle?: { targa?: string; marca?: string; modello?: string }
}

const STATO_COLOR: Record<string, string> = {
  ATTESA: 'default',
  CONFERMATA: 'blue',
  IN_LAVORAZIONE: 'orange',
}

const columns = [
  {
    title: 'Data/Ora',
    dataIndex: 'data_ora',
    key: 'data_ora',
    width: 130,
    render: (v: string) =>
      v
        ? new Date(v).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
        : '—',
  },
  {
    title: 'Cliente',
    key: 'cliente',
    render: (_: unknown, r: PrenotazioneRow) =>
      r.customer
        ? [r.customer.nome, r.customer.cognome].filter(Boolean).join(' ') || '—'
        : '—',
  },
  {
    title: 'Veicolo',
    key: 'veicolo',
    render: (_: unknown, r: PrenotazioneRow) => (
      <Space size={4}>
        {r.vehicle?.targa && <Tag color="geekblue">{r.vehicle.targa}</Tag>}
        <span>{[r.vehicle?.marca, r.vehicle?.modello].filter(Boolean).join(' ')}</span>
      </Space>
    ),
  },
  {
    title: 'Stato',
    dataIndex: 'stato',
    key: 'stato',
    width: 110,
    render: (v: string) => <Tag color={STATO_COLOR[v] ?? 'default'}>{v ?? '—'}</Tag>,
  },
]

export function TablePrenotazioniCambioWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<PrenotazioneRow[]>({
    queryKey: ['dashboard', 'prenotazioni-cambio-list'],
    queryFn: async () => {
      const res = await axiosInstance.get('/tire-service/prenotazioni/prossime', { params: { giorni: 7 } })
      return Array.isArray(res.data) ? res.data : []
    },
    staleTime: 60000,
  })

  return (
    <Card size="small" title="Prenotazioni cambio gomme (7gg)">
      <Table
        columns={columns}
        dataSource={data ?? []}
        rowKey="id"
        size="small"
        loading={isLoading}
        pagination={false}
        scroll={{ x: 500 }}
        locale={{ emptyText: 'Nessuna prenotazione' }}
        onRow={() => ({ onClick: () => navigate('/tire-service'), style: { cursor: 'pointer' } })}
      />
    </Card>
  )
}
